<template>
      <div no-body class="lku-ap2"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else >
            <b-input-group size="sm" class="m-3">
                <b-input-group-prepend> <span class="pr-2">Filter </span></b-input-group-prepend>
                <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
            </b-input-group>
            <!-- <b-input-group size="sm" class="ml-4">
                <b-input-group-prepend class="ml-5"> <span class="pr-2">On</span>
                </b-input-group-prepend>
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox value="nomor">Voucher Number</b-form-checkbox>
                  <b-form-checkbox value="uraian">Description</b-form-checkbox>
                  <b-form-checkbox value="umasuk">Debit Amount</b-form-checkbox>
                  <b-form-checkbox value="ukeluar">Credit Amount</b-form-checkbox>
                </b-form-checkbox-group>
            </b-input-group> -->
            <!-- <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label> -->
      </b-row>
        <b-table
          class="mb-0"
          ref="tblAP2" style="font-size:smaller;" 
          responsive small striped hover
          :items="tblData.items"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
          :filter="filterInput"
          @filtered="onFiltered"                
        >
          <template v-slot:cell(totalinv)="data">
              {{data.item.totalinv | numFormat}}
          </template>

          <template v-slot:cell(nilai)="data">
            {{data.item.nilai | numFormat}}
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
</template>
<style lang="scss">
  .lku-ap2 {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import amortization from '../../apis/amortization';
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      lkuLoading:false,
      fields: [
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "AP. Number",
            sortable: true
          },
          // {
          //   key: "tanggal",
          //   thStyle: "width:100px",
          //   label: "AP. Date",
          //   sortable: true
          // },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            thStyle: "width:220px",
            sortable: true
          },
          {
            key: "invoice",
            thStyle: "width:120px",
            label: "Invoice #",
            sortable: true
          },
          {
            key: "uraian_dt",
            label: "Description",
          },
          {
            key: "kodeacc",
            label: "Account#",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "matauang",
            thStyle: "width:20px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "nilai",
            label: "Prepaid Amount",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'nomor',
        sortDesc: true
      },
      filterShow:'Show',
      filter: null,
      filterOn: [],   
      filterInput:null
    };
  },
  props: ["outstand", "tagihandp"],
  created: async function() {
     this.data();
  },
watch:{
    filterShow: function(newval) {
      setTimeout(() => {
           if (this.filterShow=='Show') {
             this.filterInput='';
             this.filter='';
            }
      }, 200);
    },
    filter: function(newval) {
      setTimeout(() => {
           if ( this.filterInput!=newval) this.filterInput=newval;
      }, 800);
    },
    
  },   
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.lkuLoading=true;
      this.tblData.items= await amortization.apprepaid();      
      this.lkuLoading=false;
    },
    selectItem(item,index) {
          this.$emit("click", item);
    },
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    keymonitor: function(event) {
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblAP2.refresh();
       }
    },    
    refresh() {
      this.$refs.tblAP2.refresh();
    }
  }
};
</script>
